import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=69768d5b"
import script from "./TablePagination.vue?vue&type=script&lang=ts"
export * from "./TablePagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports